module.exports = __webpack_public_path__ + "img/14.12f9e10b.png";